export default __webpack_public_path__ + "static/rent-description-image2-e8ded1e6c05a1143a9731f7cf0f1c0d8.jpg";